module.exports = __webpack_public_path__ + "static/media/f_hairstyle_wavy_short_front_shadow.37c72a33.png";